// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // <--- Importa auth

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmsUHd8YikACKlXsCRyCsPQ4MjhKIzDJs",
  authDomain: "react-9122c.firebaseapp.com",
  projectId: "react-9122c",
  storageBucket: "react-9122c.appspot.com",
  messagingSenderId: "389228744175",
  appId: "1:389228744175:web:6d5928e40d99c775937a1a",
  measurementId: "G-R25BC1BZWB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(app); // <--- Exporta auth
